import { isClient } from './isClient';

interface NewRelic {
  noticeError: (error: Error, customAttributes?: object) => void;
  log: (
    message: string,
    options?: { customAttributes?: object; level?: 'debug|error|info|trace|warn' }
  ) => void;
}

type WindowWithNewRelic = Window & { newrelic?: NewRelic };

const getNewRelic = () => {
  if (isClient()) {
    return (window as unknown as WindowWithNewRelic).newrelic;
  }

  return null;
};

export const captureMessage = (message: string, context?: Record<string, boolean | string>) => {
  getNewRelic()?.log(message, context && { customAttributes: context });
};

/** @deprecated For capturing errors/exceptions, use captureException instead. For messages, use captureMessage. */
export const captureError = captureMessage;

export const captureException = (error: any) => {
  getNewRelic()?.noticeError(error);
};
